import React, { useEffect } from 'react';
import { Award, Timer, Star, Crown, Brain } from 'lucide-react';
import { Language } from '../types';

interface BadgeNotificationProps {
  badge: {
    name: string;
    description: string;
    icon: string;
  };
  language: Language;
  onClose: () => void;
}

const BadgeNotification: React.FC<BadgeNotificationProps> = ({ badge, language, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  const getIcon = (iconName: string) => {
    switch (iconName) {
      case 'Award':
        return <Award className="h-8 w-8" />;
      case 'Timer':
        return <Timer className="h-8 w-8" />;
      case 'Star':
        return <Star className="h-8 w-8" />;
      case 'Crown':
        return <Crown className="h-8 w-8" />;
      case 'Brain':
        return <Brain className="h-8 w-8" />;
      default:
        return <Award className="h-8 w-8" />;
    }
  };

  return (
    <div className="fixed bottom-4 right-4 z-50 animate-slide-up">
      <div className="bg-white dark:bg-slate-800 rounded-lg shadow-lg border-2 border-indigo-500 dark:border-indigo-400 p-4 max-w-sm">
        <div className="flex items-center gap-4">
          <div className="text-indigo-600 dark:text-indigo-400">
            {getIcon(badge.icon)}
          </div>
          <div className="flex-1">
            <h3 className="font-semibold text-indigo-700 dark:text-indigo-300">
              {language === 'en' ? 'New Badge Earned!' : 'Nouveau Badge Obtenu !'}
            </h3>
            <p className="text-sm font-medium text-slate-800 dark:text-slate-200">{badge.name}</p>
            <p className="text-xs text-slate-600 dark:text-slate-400">{badge.description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BadgeNotification;